export default __webpack_public_path__ + "static/media/MaskGroup208.c8971c7d.png";